import React from 'react';
import { StarIcon, CheckCircle2Icon } from 'lucide-react';
export function TopTrustBar() {
  return <div className="bg-gray-50 border-b border-gray-200 text-xs sm:text-sm text-gray-700" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-6 gap-y-1" data-id="element-65">
        <span className="flex items-center gap-1.5" data-id="element-66">
          <CheckCircle2Icon className="w-4 h-4 text-ofri-blue" data-id="element-67" />
          <span data-id="element-68">
            <span className="font-semibold text-gray-900" data-id="element-69">150'000+</span>{' '}
            zufriedene Kunden
          </span>
        </span>
        <span className="hidden sm:inline text-gray-300" data-id="element-70">·</span>
        <span className="flex items-center gap-1.5" data-id="element-71">
          <CheckCircle2Icon className="w-4 h-4 text-ofri-blue" data-id="element-72" />
          <span data-id="element-73">
            <span className="font-semibold text-gray-900" data-id="element-74">200+</span> geprüfte
            Malerfirmen
          </span>
        </span>
        <span className="hidden sm:inline text-gray-300" data-id="element-75">·</span>
        <span className="flex items-center gap-1" data-id="element-76">
          <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-77" />
          <span data-id="element-78">
            <span className="font-semibold text-gray-900" data-id="element-79">4.8/5</span> auf
            Google
          </span>
        </span>
      </div>
    </div>;
}